export default function (date: string = '', format: string = 'DD/MM/YYYY à HH:mm') {
  const dayjs = useDayjs()
  return dayjs(date).format(format)
}
